import {ListItem, ListItemButton, ListItemIcon} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {Notifications} from "@mui/icons-material";
import React, {useEffect, useState} from "react";
import {FileDownloadNotificationListItem} from "./file-download-notification-list-item";

export const NotificationListItem = (notification) => {
    const [details, setDetails] = useState(undefined);
    useEffect(() => {
        if (notification) {
            const deets = notification.notification.notification.notificationDetails;
            setDetails(deets);
        }
    }, [notification]);


  return (
      <ListItem>
          <ListItemButton>
              <ListItemIcon>
                  <IconButton>
                      <Notifications color={'error'}/>
                  </IconButton>
              </ListItemIcon>
              {
                  details && (
                      details["type"] === "order-of-service" ||
                      details["type"] === "study-note" ||
                      details["type"] === "tithe-report" ||
                      details["type"] === "finance-report"
                  )  ?
                      <FileDownloadNotificationListItem details={details}/>
                      : null
              }
          </ListItemButton>
      </ListItem>
  )
}
